import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';

export const getAltPostalCode = createAsyncThunk('altPostalCode/getAltPostalCode', async (data, thunkApi) => {
  try {
    const response = await agent.requests.get(`/subscriptions/get-address-by-vops`, { params: data });
    return response;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const confirmAltPostalCodeDetails = createAsyncThunk('altPostalCode/confirmAltPostalCode', async (data, thunkApi) => {
  try {
    const response = await agent.requests.post('/subscriptions/get-address-by-vops', data);
    return response;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

const initialState = {
  status: 'idle',
  loading: false,
  error: null,
  getAltPostalCodeResponse: null,
  confirmAltPostalCodeDetailsResponse: null
};

const altPostalCodeSlice = createSlice({
  name: 'altPostalCode',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(getAltPostalCode.pending, (state) => {
        state.status = 'getAltPostalCode/loading';
      })
      .addCase(getAltPostalCode.fulfilled, (state, action) => {
        state.status = 'getAltPostalCode/success';
        state.getAltPostalCodeResponse = action.payload;
      })
      .addCase(getAltPostalCode.rejected, (state, action) => {
        state.status = 'getAltPostalCode/failed';
        state.error = action.payload;
      })

      .addCase(confirmAltPostalCodeDetails.pending, (state) => {
        state.status = 'confirmAltPostalCode/loading';
      })
      .addCase(confirmAltPostalCodeDetails.fulfilled, (state, action) => {
        state.status = 'confirmAltPostalCode/success';
        state.confirmAltPostalCodeDetailsResponse = action.payload;
      })
      .addCase(confirmAltPostalCodeDetails.rejected, (state, action) => {
        state.status = 'confirmAltPostalCode/failed';
        state.error = action.payload;
      });
  }
});

export const { resetStatus } = altPostalCodeSlice.actions;

export const selectAltPostalCodeStatus = (state) => state.altPostalCode?.status;

export const selectAltPostalCodeResponse = (state) => state.altPostalCode?.getAltPostalCodeResponse;

export const selectConfirmAltPostalCodeResponse = (state) => state.altPostalCode?.confirmAltPostalCodeDetailsResponse;

export const selectAltPostalCodeError = (state) => state.altPostalCode?.error;

export default altPostalCodeSlice.reducer;
